// Declare global types for gtag
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    gtag_report_conversion?: () => void;
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const gtagId = config.public.gtagId || process.env.NUXT_PUBLIC_GTAG_ID;

  // Skip initialization if gtagId is not provided
  if (!gtagId) {
    return;
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];

  // Define gtag function
  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }

  // Make gtag available globally
  window.gtag = gtag;

  // Check if script is already loaded
  const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`);

  if (!existingScript) {
    // Create and append the gtag script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    document.head.appendChild(script);
  }

  // Initialize gtag configuration
  gtag('js', new Date());
  gtag('config', gtagId);
});
